import { environment } from '../../../environments/environment';
import { resolveTenant } from './tenant';

export type IdentityProvider = 'keycloak' | 'auth0';

export const TENANT = resolveTenant(environment.DEFAULT_DEV_TENANT);

export const IDENTITY_PROVIDER: IdentityProvider = environment.KEYCLOAK_TENANTS.includes(TENANT)
  ? 'keycloak'
  : 'auth0';
